import * as yup from 'yup';
import {
  acessoContraCheque,
  acessoInformeDeRendimentos,
} from './utils/rulesByKey';

export const ContrachequeSchema = yup.object({
  ...acessoContraCheque,
  ...acessoInformeDeRendimentos,
});

export const ContrachequeInitialValues = {
  acessoContraCheque: '',
  acessoInformeDeRendimentos: '',
};
